import * as Yup from "yup";

export const validation = Yup.object().shape({
  name: Yup.string().required("กรุณากรอก"),
  base_uom_document_id: Yup.string().required("กรุณากรอก"),
});
